import React from 'react';
import { noop } from 'lodash';
import { IPolicyVersion, IPolicy, IShare } from './types';

type Noop = typeof noop;
interface IPolicyData {
  id: number;
  vid: number;
  name: string;
  shares: IShare[];
}
interface Input {
  policy: IPolicyData;
}

interface IProps {
  deletePolicy: ((id: number) => void) | Noop;
  activatePolicy: ((id: number) => void) | Noop;
  updatePolicy: ((data: Input) => void) | Noop;
  reorderPolicies: ((order: number[]) => void) | Noop;
  clonePolicy: ((id: number) => void) | Noop;
  editPolicy: ((policy: IPolicy, version: IPolicyVersion) => void) | Noop;
}

export default React.createContext<IProps>({
  deletePolicy: noop,
  activatePolicy: noop,
  updatePolicy: noop,
  reorderPolicies: noop,
  clonePolicy: noop,
  editPolicy: noop,
});

export { IProps };
